module.exports = __webpack_public_path__ + "static/img/7.3287375.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/7.png
// module id = k3sT
// module chunks = 0